module.exports = __webpack_public_path__ + "img/11.6dfa3e18.png";